export const LiquidUniv4EthDevBuyAbi = [
  {
    type: "constructor",
    inputs: [
      { name: "factory_", type: "address" },
      { name: "weth_", type: "address" },
      { name: "universalRouter_", type: "address" },
      { name: "permit2_", type: "address" },
    ],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "factory",
    inputs: [],
    outputs: [{ name: "", type: "address" }],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "weth",
    inputs: [],
    outputs: [{ name: "", type: "address" }],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "universalRouter",
    inputs: [],
    outputs: [{ name: "", type: "address" }],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "permit2",
    inputs: [],
    outputs: [{ name: "", type: "address" }],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "receiveTokens",
    inputs: [
      {
        name: "deploymentConfig",
        type: "tuple",
        components: [
          {
            name: "tokenConfig",
            type: "tuple",
            components: [
              { name: "tokenAdmin", type: "address" },
              { name: "name", type: "string" },
              { name: "symbol", type: "string" },
              { name: "salt", type: "bytes32" },
              { name: "image", type: "string" },
              { name: "metadata", type: "string" },
              { name: "context", type: "string" },
              { name: "originatingChainId", type: "uint256" },
            ],
          },
          {
            name: "poolConfig",
            type: "tuple",
            components: [
              { name: "hook", type: "address" },
              { name: "pairedToken", type: "address" },
              { name: "tickIfToken0IsLiquid", type: "int24" },
              { name: "tickSpacing", type: "int24" },
              { name: "poolData", type: "bytes" },
            ],
          },
          {
            name: "lockerConfig",
            type: "tuple",
            components: [
              { name: "locker", type: "address" },
              { name: "rewardAdmins", type: "address[]" },
              { name: "rewardRecipients", type: "address[]" },
              { name: "rewardBps", type: "uint16[]" },
              { name: "tickLower", type: "int24[]" },
              { name: "tickUpper", type: "int24[]" },
              { name: "positionBps", type: "uint16[]" },
              { name: "lockerData", type: "bytes" },
            ],
          },
          {
            name: "mevModuleConfig",
            type: "tuple",
            components: [
              { name: "mevModule", type: "address" },
              { name: "mevModuleData", type: "bytes" },
            ],
          },
          {
            name: "extensionConfigs",
            type: "tuple[]",
            components: [
              { name: "extension", type: "address" },
              { name: "msgValue", type: "uint256" },
              { name: "extensionBps", type: "uint16" },
              { name: "extensionData", type: "bytes" },
            ],
          },
        ],
      },
      {
        name: "tokenPoolKey",
        type: "tuple",
        components: [
          { name: "currency0", type: "address" },
          { name: "currency1", type: "address" },
          { name: "fee", type: "uint24" },
          { name: "tickSpacing", type: "int24" },
          { name: "hooks", type: "address" },
        ],
      },
      { name: "token", type: "address" },
      { name: "extensionSupply", type: "uint256" },
      { name: "extensionIndex", type: "uint256" },
    ],
    outputs: [],
    stateMutability: "payable",
  },
  {
    type: "function",
    name: "supportsInterface",
    inputs: [{ name: "interfaceId", type: "bytes4" }],
    outputs: [{ name: "", type: "bool" }],
    stateMutability: "pure",
  },
  {
    type: "event",
    name: "EthDevBuy",
    inputs: [
      { name: "token", type: "address", indexed: true },
      { name: "user", type: "address", indexed: true },
      { name: "ethAmount", type: "uint256", indexed: false },
      { name: "tokenAmount", type: "uint256", indexed: false },
    ],
    anonymous: false,
  },
  { type: "error", name: "InvalidEthDevBuyPercentage", inputs: [] },
  { type: "error", name: "InvalidMsgValue", inputs: [] },
  { type: "error", name: "InvalidPairedTokenPoolKey", inputs: [] },
  { type: "error", name: "ReentrancyGuardReentrantCall", inputs: [] },
  { type: "error", name: "Unauthorized", inputs: [] },
] as const;
